import React, { useState } from "react";
import { SingleSelect } from "react-select-material-ui";

const selectStyles = (open) => ({
  singleValue: (provided) => ({ ...provided, color: "#666" }),
  menu: (provided) => ({
    ...provided,
    marginTop: 4,
    border: "1px solid #0086E6",
    fontSize: 14,
    height: open ? "auto" : "0px",
    overflow: "hidden",
    opacity: open ? 1 : 0,
    transition: "all 0.1s ease-in-out",
    visibility: open ? "visible" : "hidden",
    zIndex: 100,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: "#fff",
    color: "#000",
    borderBottom: state.data.value === "" ? "none" : "1px solid #0086E6",
  }),
});

const SelectInput = ({ handleChange, options, label, minWidth, name, data, selectRef }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className={`relative flex  w-[220px] ${minWidth ? minWidth : "md:w-[360px]"}`} onClick={() => setOpen(!open)}>
        <SingleSelect
          label={label || "Property Type"}
          options={options}
          name={name}
          onChange={handleChange}
          placeholder={label || "Property Type"}
          value={data?.value || ""}
          SelectProps={{
            ref: selectRef,
            isCreatable: false,
            isSearchable: false,
            components: {
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            },
            menuIsOpen: true,
            onBlur: () => setOpen(false),
            styles: selectStyles(open),
            className: "border border-primary z-50 font-Montserrat z-auto rounded h-[50px] focus:outline-none text-[14px] font-semibold",
          }}
        />

        {open ? (
          <i className="fa-solid text-primary top-[26px] -translate-y-1/2 right-4 absolute fa-angle-up text-[20px]"></i>
        ) : (
          <i className="fa-solid text-primary top-[26px] -translate-y-1/2 right-4 absolute fa-angle-down text-[20px]"></i>
        )}
      </div>
      {data?.errorMessage && !data?.valid && data?.touched && (
        <div className={"text-[0.74rem] text-red-600 ml-2 text-left font-roboto"}>{data?.errorMessage}</div>
      )}
    </>
  );
};

export default SelectInput;
